import { useRef, useState, useEffect } from "react";
import { FaPrint } from "react-icons/fa";
import { AiOutlineUpload } from "react-icons/ai";
import API_URL from "../Config";
import Loader from "../Components/Loader";
import "../Forms/Certificate.css";
import "./Table.css";
// import Pagination from "../Components/Pagination";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import axiosInstance from "../axiosinstance";
import DownloadExcel from "../Components/DownloadExcel";
import { TbFileImport } from "react-icons/tb";
import { PiExport } from "react-icons/pi";
import { ToastContainer, toast, Bounce } from "react-toastify";
import { IoIosClose } from "react-icons/io";
import { FiInfo, FiPlus } from "react-icons/fi";
import "react-toastify/dist/ReactToastify.css";


// import Pagination from "../Components/Pagination";
import {
  Pagination,
  Stack,
  CircularProgress,
  Box,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";

const certStyle = {
  // border: "1px solid black",
  padding: "10px",
  margin: "20px auto",
  width: "100%",
  backgroundColor: "#fff",
};

function AllTags({
  isSidebarExpanded,
  equipmentNameFilter,
  equipmentTagFilter,
  activeTab: tableActiveTab,
  selectedProjectId,
  canImport = true,
}) {
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(false);
  const [printLoading, setPrintLoading] = useState(false);
  const [importLoading, setImportLoading] = useState(false);

  const [showPopup, setShowPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  // const [selectedFlanges, setSelectedFlanges] = useState([]);
  const [timezones, setTimezones] = useState([]);
  const [timezoneLoading, setTimezoneLoading] = useState(false);
  const [timezoneError, setTimezoneError] = useState("");

  // const [isimportted, setisimported] = useState(false);
  const [isimportted, setIsimportted] = useState(false);
  const [selectedFlanges, setSelectedFlanges] = useState([]);
  const [selectedTimezone, setSelectedTimezone] = useState("");
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [selectedFile, setSelectedFile] = useState(null);
  const [importId, setImportId] = useState(null);
  const [importWarnings, setImportWarnings] = useState([]);
  const [responseData, setResponseData] = useState({});
  const [selectedSheets, setSelectedSheets] = useState([]);
  const [sheetGroupMapping, setSheetGroupMapping] = useState({});
  const [sheetMappingError, setSheetMappingError] = useState("");
  const [createGroupSheet, setCreateGroupSheet] = useState(null);
  const [newEquipmentGroup, setNewEquipmentGroup] = useState({ code: "", description: "" });
  const [createGroupLoading, setCreateGroupLoading] = useState(false);
  const [createGroupError, setCreateGroupError] = useState("");

  const [showMissingTagsModal, setShowMissingTagsModal] = useState(false);
  const [missingTagInfo, setMissingTagInfo] = useState(null);
  const [confirmMissingTags, setConfirmMissingTags] = useState(false); // toggle this for resending

  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [showSheetConfig, setShowSheetConfig] = useState(false);
  const [sheetConfigLoading, setSheetConfigLoading] = useState(false);
  const [sheetInfo, setSheetInfo] = useState(null);
  const [flangeRefreshKey, setFlangeRefreshKey] = useState(0);

  const [isLoading, setIsLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [totalRecords, setTotalRecords] = useState(0);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentAdmins = admins.slice(startIndex, endIndex);


  const printRef = useRef();

  const [headerConfig, setHeaderConfig] = useState(null);
  const [mappingTab, setMappingTab] = useState("");
  const [showHeaderConfig, setShowHeaderConfig] = useState(false);
  const [headerMappingData, setHeaderMappingData] = useState(null);
  // const [showExistingExcelPopup, setShowExistingExcelPopup] = useState(false);
  const [existingFile, setExistingFile] = useState(null);
  const [existingUploadLoading, setExistingUploadLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("new");

  const handleHeaderChange = (sheetName, field, newValue) => {
    setHeaderConfig((prev) => ({
      ...prev,
      header_data: {
        ...prev.header_data,
        [sheetName]: {
          ...prev.header_data[sheetName],
          mappings: {
            ...prev.header_data[sheetName].mappings,
            [field]: newValue,
          },
        },
      },
    }));
  };

  useEffect(() => {
    if (
      headerConfig?.header_data &&
      Object.keys(headerConfig.header_data).length > 0
    ) {
      setMappingTab(Object.keys(headerConfig.header_data)[0]); // Set first tab as default
    }
  }, [headerConfig]);

  // const handleExistingExcelSubmit = async () => {
  //   if (!existingFile) {
  //     toast.error("Please choose an Excel file first.");
  //     return;
  //   }
  //   try {
  //     setExistingUploadLoading(true);

  //     const projectParam = resolveProjectParam();
  //     if (!projectParam) {
  //       toast.error("Project not selected.");
  //       setExistingUploadLoading(false);
  //       return;
  //     }

  //     const formData = new FormData();
  //     formData.append("file", existingFile);

  //     const res = await axiosInstance.post(
  //       `${API_URL}/api/upload_and_edit/${projectParam}`,
  //       formData,
  //       { headers: { "Content-Type": "multipart/form-data" } }
  //     );

  //     const updated = Number(res?.data?.updated ?? 0);
  //     const msg = res?.data?.message || "";

  //     if (updated > 0) {
  //       toast.success(msg || "Flange updated.");
  //       localStorage.setItem("flangeRefresh", Date.now());
  //       window.dispatchEvent(new Event("flangeUpdated"));
  //       setShowExistingExcelPopup(false);
  //       setExistingFile(null);
  //     } else {
  //       toast.error(msg || "No rows were updated. Please verify the Excel file.");
  //     }
  //   } catch (err) {
  //     const apiErr =
  //       err?.response?.data?.message ||
  //       err?.response?.data?.error ||
  //       err?.message ||
  //       "Upload failed.";
  //     toast.error(apiErr);
  //   } finally {
  //     setExistingUploadLoading(false);
  //   }
  // };

  const handleImportClick = async ({ onImportSuccess }) => {
    if (!canImport) return;
    let shouldCloseImportPopup = false;
    // if (!selectedTimezone) {
    //   setSnackbarMessage("❗ Please select a timezone.");
    //   setShowSnackbar(true);
    //   return;
    // }

    if (!selectedFile) {
      setSnackbarMessage("❗ Please select a file to import.");
      setShowSnackbar(true);
      return;
    }

    const selectedProject = JSON.parse(localStorage.getItem("selectedProject"));

    if (!selectedProject || selectedProject.length === 0) {
      setSnackbarMessage("❗ Project not selected.");
      setShowSnackbar(true);
      return;
    }

    if (!selectedTemplate) {
      setSnackbarMessage("❗ Please select a template.");
      setShowSnackbar(true);
      return;
    }

    setIsimportted(true);
    setLoading(true);
    setErrorMessage("");
    setSuccessMessage("");

    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("timezone", selectedTimezone);

    // 💡 Append project_id(s)
    // If you want to send just one (e.g., first one):
    formData.append("project_selected", selectedProject);
    formData.append("template_type", selectedTemplate);

    // If API supports multiple:
    // selectedProject.forEach((id) => formData.append("project_ids[]", id));

    try {
      const uploadRes = await axiosInstance.post(
        `/api/import_formatted_excel`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      const warnings = uploadRes.data?.warnings || [];
      setImportWarnings(warnings);
      setFlangeRefreshKey((prev) => prev + 1);
      if (typeof onImportSuccess === "function") {
        onImportSuccess();
      }

      // ✅ Check for success message and trigger refresh
      if (uploadRes.data?.message === "Import successful") {
        // Refresh flange table like in header config
        localStorage.setItem("flangeRefresh", Date.now());
        window.dispatchEvent(new Event("flangeUpdated"));
      }

      const newImportId = uploadRes.data?.import_id;
      if (!newImportId) throw new Error("Import ID not returned from server");

      setImportId(newImportId);
      shouldCloseImportPopup = true;
      // await fetchFlangesPage(newImportId, 1);

      // setSnackbarMessage("✅ File imported and data fetched successfully!");
      setSelectedFile(null);
      // setSelectedTimezone("");
    } catch (error) {
      console.error("❌ Import Error:", error);
      const errorMsg = error?.response?.data?.error;

      if (errorMsg === "Unsupported template type") {
        // 👉 Show the header selection popup
        // setShowSheetConfig(true); // You'll create this state
        // return;
        try {
          const sheetForm = new FormData();
          sheetForm.append("file", selectedFile);
          sheetForm.append("project_selected", selectedProject);
          sheetForm.append("template_type", selectedTemplate);
          sheetForm.append("timezone", selectedTimezone);

          const sheetRes = await axiosInstance.post(
            "/api/get_excel_sheets",
            sheetForm,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );

          // ⬇️ Save data for sheet config popup
          const returnedMappings = Array.isArray(sheetRes.data?.sheet_mappings)
            ? sheetRes.data.sheet_mappings
            : [];
          const initialGroupMapping = returnedMappings.reduce(
            (mapping, sheet) => ({
              ...mapping,
              [sheet.sheet_name]: sheet.equipment_group_id || "",
            }),
            {}
          );

          setSheetInfo(sheetRes.data);
          setSelectedSheets(returnedMappings.map((sheet) => sheet.sheet_name));
          setSheetGroupMapping(initialGroupMapping);
          setSheetMappingError("");
          shouldCloseImportPopup = true;
          setShowSheetConfig(true); // ⬅️ Show the popup
          return;
        } catch (sheetErr) {
          console.error("Failed to fetch sheet info:", sheetErr);
          const sheetErrorMessage =
            sheetErr?.response?.data?.error ||
            sheetErr?.response?.data?.message ||
            "Failed to read the Excel sheets. Please verify the file and try again.";
          setErrorMessage(sheetErrorMessage);
          setSnackbarMessage(`Import could not continue: ${sheetErrorMessage}`);
          setShowSnackbar(true);
          return;
        }
      }

      const importErrorMessage =
        error?.response?.data?.message ||
        errorMsg ||
        "Error importing the file. Please try again.";
      setErrorMessage(importErrorMessage);
      setSnackbarMessage(importErrorMessage);
      setShowSnackbar(true);
    } finally {
      setLoading(false);
      if (shouldCloseImportPopup) {
        setShowPopup(false);
      }
    }
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    setImportWarnings([]); // ✅ clear here
  };

  const handleSheetConfigSubmit = async (e) => {
    e.preventDefault();

    if (sheetConfigLoading) return;

    const sheetMappings = Array.isArray(sheetInfo?.sheet_mappings)
      ? sheetInfo.sheet_mappings
      : [];
    const unmappedSheets = sheetMappings
      .map((sheet) => sheet.sheet_name)
      .filter(
        (sheetName) =>
          selectedSheets.includes(sheetName) && !sheetGroupMapping[sheetName]
      );

    if (unmappedSheets.length > 0) {
      const message = `Select an equipment group for: ${unmappedSheets.join(", ")}.`;
      setSheetMappingError(message);
      setSnackbarMessage(message);
      setShowSnackbar(true);
      return;
    }

    setSheetMappingError("");
    setSheetConfigLoading(true);

    try {
      const confirmedSheetGroupMapping = selectedSheets.reduce(
        (mapping, sheetName) => ({
          ...mapping,
          [sheetName]: sheetGroupMapping[sheetName],
        }),
        {}
      );
      const payload = {
        session_id: sheetInfo.session_id,
        sheet_names: selectedSheets,
        selected_sheets: selectedSheets,
        sheet_group_mapping: confirmedSheetGroupMapping,
        project_selected: sheetInfo.project_selected,
        timezone: sheetInfo.timezone,
      };

      const res = await axiosInstance.post(
        `/api/selected_excel_sheet`,
        payload
      );

      if (res.status === 200 && res.data?.success && res.data.sheets) {
        console.log("Header data received:", res.data);

        // ✅ Transform response into header_data object with mappings
        const header_data = {};
        res.data.sheets.forEach((sheet) => {
          if (sheet.sheet) {
            header_data[sheet.sheet] = {
              detected_headers: sheet.detected_headers || [],
              mappings: sheet.suggested_mappings || {},
            };
          }
        });

        // ✅ Save transformed data
        setHeaderConfig({
          session_id: res.data.session_id,
          project_selected: res.data.project_selected,
          timezone: res.data.timezone,
          sheet_group_mapping: confirmedSheetGroupMapping,
          header_data: header_data,
        });

        setHeaderMappingData(true);
        setShowHeaderConfig(true);
        setShowSheetConfig(false);
        setSnackbarMessage("✅ Sheet selection submitted successfully!");
        setShowSnackbar(true);
      } else {
        setSnackbarMessage(
          res.data?.message || "❗ Failed to submit selected sheets."
        );
        setShowSnackbar(true);
      }
    } catch (error) {
      console.error("Submit Error:", error);
      setSnackbarMessage(
        "❗ An error occurred while submitting selected sheets."
      );
      setShowSnackbar(true);
    } finally {
      setSheetConfigLoading(false);
    }
  };

  const handleCreateEquipmentGroup = async (e) => {
    e.preventDefault();
    if (createGroupLoading || !createGroupSheet) return;

    const code = newEquipmentGroup.code.trim().toUpperCase();
    const description = newEquipmentGroup.description.trim();
    if (!code || !description) {
      setCreateGroupError("Enter both a group code and group name.");
      return;
    }

    setCreateGroupLoading(true);
    setCreateGroupError("");
    try {
      const response = await axiosInstance.post("/api/equipment-groups", {
        code,
        description,
      });
      const createdGroup = response.data;

      setSheetInfo((current) => ({
        ...current,
        all_equipment_groups: [
          ...(current?.all_equipment_groups || []),
          createdGroup,
        ],
      }));
      setSheetGroupMapping((current) => ({
        ...current,
        [createGroupSheet]: createdGroup.id,
      }));
      setSnackbarMessage(`${description} was created and selected.`);
      setShowSnackbar(true);
      setCreateGroupSheet(null);
      setNewEquipmentGroup({ code: "", description: "" });
    } catch (error) {
      setCreateGroupError(
        error?.response?.data?.error || "Unable to create the equipment group."
      );
    } finally {
      setCreateGroupLoading(false);
    }
  };

  // const handleHeaderConfigSubmit = async () => {

  //   try {
  //     const payload = {
  //       session_id: headerConfig.session_id,
  //       selected_sheets: Object.keys(headerConfig.header_data),
  //       header_row_index: 1,
  //       project_selected: headerConfig.project_selected || sheetInfo.project_selected,
  //       timezone: headerConfig.timezone || sheetInfo.timezone,
  //       header_mappings: {}, // Fix happens here
  //     };

  //     // ✅ Correctly extract mappings for each sheet
  //     Object.entries(headerConfig.header_data).forEach(([sheetName, sheetData]) => {
  //       const { mappings = {} } = sheetData;
  //       payload.header_mappings[sheetName] = {};

  //       Object.entries(mappings).forEach(([fieldName, mappedHeader]) => {
  //         if (mappedHeader) {
  //           payload.header_mappings[sheetName][fieldName] = mappedHeader;
  //         }
  //       });
  //     });

  //     console.log("✅ Final payload", payload); // Debug output

  //     const res = await axiosInstance.post(`/api/imports`, payload);
  //  console.log("Raw import response:", res);

  //    if (res.data?.flanges_inserted >= 0){
  //     setShowHeaderConfig(false);
  //     setSnackbarMessage("✅ Headers configured and import started!");
  //     setShowSnackbar(true);

  //     window.localStorage.setItem("flangeRefresh", Date.now());
  //     window.dispatchEvent(new Event("flangeUpdated"));
  //   } else {
  //     console.warn("Import failed or success not returned properly:", res.data);
  //     throw new Error("Header confirmation failed.");
  //   }

  // } catch (error) {
  //   console.error("Header confirm error:", error);
  //   setSnackbarMessage("❌ Error while confirming headers.");
  //   setShowSnackbar(true);
  // }
  // };

  //  const fetchFlangesPage = async (importId, page) => {
  //   try {
  //     setLoading(true);
  //     const res = await axiosInstance.get(
  //       `/api/flanges_processed_in_this_import/${importId}?page=${page}`
  //     );
  //     const { data, total_records, Items_per_page, } = res.data;

  //     setAdmins(data);
  //     setTotalRecords(total_records);
  //     setItemsPerPage(Items_per_page);

  //     console.log("data=",data)
  //     console.log("total_records=",total_records)
  //     console.log("Items_per_page=",Items_per_page)
  //   } catch (err) {
  //     console.error("❌ Pagination fetch error:", err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  //   useEffect(() => {
  //   if (importId) {
  //     fetchFlangesPage(importId, currentPage, itemsPerPage);
  //   }
  // }, [importId, currentPage, itemsPerPage]);

  // const handleHeaderConfigSubmit = async (confirmMissing = false) => {
  //   setIsLoading(true);

  //   try {
  //     const payload = {
  //       session_id:'',
  //       selected_sheets:'',
  //       header_row_index:'',
  //       header_mappings:'',
  //       ...(confirmMissing && { confirm_missing_tags: true }), // add this only if confirmMissing === true
  //     };

  //     const response = await axiosInstance.post(
  //       `${API_URL}/submit_header_config`,
  //       payload
  //     );

  //     if (
  //       response.data?.message === "Tag number missing for some rows" &&
  //       response.data?.missing_tags &&
  //       !confirmMissing // only show popup on FIRST call
  //     ) {
  //       setMissingTagInfo(response.data.missing_tags);
  //       setShowMissingTagsModal(true);
  //       setIsLoading(false); // ✅ stop spinner
  //       return; // ⛔ DO NOT proceed to success
  //     }

  //     // ✅ Success case (either confirmed or no tag issue)
  //     // setSnackbarSeverity("success");
  //     setSnackbarMessage("Header configuration submitted successfully!");
  //     // setSnackbarOpen(true);
  //     // onClose(); // Close popup
  //   } catch (err) {
  //     // setSnackbarSeverity("error");
  //     setSnackbarMessage("Error submitting header config.");
  //     // setSnackbarOpen(true);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleHeaderConfigSubmit = async (confirmMissing) => {
    if (isLoading) return;

    setIsLoading(true);

    try {
      // 1. Construct the payload safely
      const payload = {
        session_id: headerConfig.session_id,
        selected_sheets: Object.keys(headerConfig.header_data),
        header_row_index: 1,
        project_selected:
          headerConfig.project_selected || sheetInfo.project_selected,
        timezone: headerConfig.timezone || sheetInfo.timezone,
        header_mappings: {},
        sheet_group_mapping: headerConfig.sheet_group_mapping || sheetGroupMapping,
        ...(confirmMissing.isPassconfirm_missing_tags
          ? { confirm_missing_tags: confirmMissing.value }
          : {}),
      };

      // 2. Populate header mappings
      Object.entries(headerConfig.header_data).forEach(
        ([sheetName, sheetData]) => {
          const { mappings = {} } = sheetData;
          payload.header_mappings[sheetName] = {};

          Object.entries(mappings).forEach(([fieldName, mappedHeader]) => {
            if (mappedHeader) {
              payload.header_mappings[sheetName][fieldName] = mappedHeader;
            }
          });
        }
      );

      console.log("✅ Final payload for import:", payload);

      // 3. Make API call with safe status handling
      const res = await axiosInstance.post(`/api/imports`, payload, {
        validateStatus: () => true, // allow non-2xx through for manual checking
      });

      console.log("📦 Raw import response:", res);

      const statusOK = res.status === 200 && res.status === 300;
      const flangesInserted = Number(res?.data?.flanges_inserted ?? -1);

      if (res.data.status === "pending_confirmation") {
        // !confirmMissing // only show popup on FIRST call
        setMissingTagInfo(res.data.information_about_mising_tags);
        setShowHeaderConfig(false);
        setShowMissingTagsModal(true);
        return; // ⛔ DO NOT proceed to success
      }

      if (res.data?.message === "Import complete.") {
        // Refresh flange table like in header config
        localStorage.setItem("flangeRefresh", Date.now());
        window.dispatchEvent(new Event("flangeUpdated"));

        setShowHeaderConfig(false);
        setShowSnackbar(true);
      }

      // 4. Success case
      // if (statusOK && flangesInserted >= 0) {
      //   setShowHeaderConfig(false);
      //   setSnackbarMessage("✅ Headers configured and import started!");
      //   setShowSnackbar(true);

      //   // Notify other parts of the app
      //   localStorage.setItem("flangeRefresh", Date.now());
      //   window.dispatchEvent(new Event("flangeUpdated"));
      // } else {
      //   // 5. Malformed or failed response
      //   console.warn("⚠️ Import failed or bad response:", res.data);
      //   throw new Error("Header confirmation failed.");
      // }
    } catch (error) {
      // 6. Catch and notify
      console.error("❌ Header config submit error:", error);
      setSnackbarMessage("❌ Error while confirming headers.");
      //   setShowHeaderConfig(false);
      // setShowSnackbar(true);
      //  localStorage.setItem("flangeRefresh", Date.now());
      //   window.dispatchEvent(new Event("flangeUpdated"));
    } finally {
      setIsLoading(false);
    }
  };

  // In AllTags.jsx - Keep this as is
  // Replace your current handleExportExcel with this
  const handleExportExcel = async () => {
    const toastId = toast.loading("Preparing export...");

    try {
      const selectedProject = JSON.parse(
        localStorage.getItem("selectedProject")
      );
      if (!selectedProject) {
        toast.update(toastId, {
          render: "❗ Please select a project first.",
          type: "error",
          isLoading: false,
          autoClose: 3000,
        });
        return;
      }

      // Build query params from current UI filters (no pagination here)
      const params = {};

      // Table tab (optional, only send if server supports it; otherwise remove)
      if (tableActiveTab) params.active_tab = tableActiveTab;

      // Filters you already have in this component
      if (equipmentNameFilter) params.equipment_name = equipmentNameFilter;
      if (equipmentTagFilter) params.tag = equipmentTagFilter;

      // If you also have a status filter in your UI, include it:
      // if (statusFilter) params.status = statusFilter;

      toast.update(toastId, {
        render: "Generating Excel file...",
        type: "info",
      });

      // ✅ IMPORTANT: use axiosInstance and a relative path (avoids CORS)
      const res = await axiosInstance.get(
        `/api/export_flange/${selectedProject}`, // ← path param
        {
          params, // ← query params (filters only)
          responseType: "blob",
          // Don't set Accept here; let the server content-type drive it
        }
      );

      // Basic empty-response guard
      if (!res.data || (res.data.size !== undefined && res.data.size === 0)) {
        toast.update(toastId, {
          render: "❗ No data for the current filters.",
          type: "warning",
          isLoading: false,
          autoClose: 3000,
        });
        return;
      }

      // Download
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      let filename = "Flanges_Export";

      if (equipmentNameFilter)
        filename += `_${equipmentNameFilter.replace(/\s+/g, "_")}`;
      if (equipmentTagFilter)
        filename += `_${equipmentTagFilter.replace(/\s+/g, "_")}`;
      if (tableActiveTab === "All Warnings") filename += "_Warnings";

      filename += `_${new Date().toISOString().slice(0, 10)}.xlsx`;

      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      toast.update(toastId, {
        render: "✅ Excel exported successfully!",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      });
    } catch (err) {
      console.error("❌ Export Error:", err);

      // If this endpoint still throws CORS in your backend, you need to enable CORS for /api/export_flange/:id
      // on the server. On the FE we stick to axiosInstance + relative path to avoid it.
      const msg =
        err?.response?.data?.error || err?.message || "Export failed.";
      toast.update(toastId, {
        render: `❌ ${msg}`,
        type: "error",
        isLoading: false,
        autoClose: 4000,
      });
    }
  };

  const handleprint = async () => {
    const input = printRef.current;
    if (!input) {
      alert("Nothing to print. Please import data first.");
      return;
    }

    // Convert NodeList to an array and filter based on selected flange IDs
    const certs = Array.from(input.querySelectorAll(".single-cert")).filter(
      (cert) => selectedFlanges.includes(cert.dataset.flangeId) // Use data-flange-id to filter selected
    );

    if (certs.length === 0) {
      alert("No selected certificates to print.");
      return;
    }

    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    for (let i = 0; i < certs.length; i++) {
      const canvas = await html2canvas(certs[i], {
        scale: 1.5,
        useCORS: true,
        allowTaint: true,
        backgroundColor: "#fff",
        logging: false,
        windowWidth: certs[i].scrollWidth,
        windowHeight: certs[i].scrollHeight,
      });

      const imgData = canvas.toDataURL("image/jpeg", 0.75);
      const imgProps = pdf.getImageProperties(imgData);
      const imgHeight = (imgProps.height * pdfWidth) / imgProps.width;

      if (i > 0) pdf.addPage();

      if (imgHeight > pdfHeight) {
        const scaledWidth = (imgProps.width * pdfHeight) / imgProps.height;
        pdf.addImage(imgData, "JPEG", 0, 0, scaledWidth, pdfHeight);
      } else {
        pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, imgHeight);
      }
    }

    pdf.save("selected-flange-certificates.pdf");
  };

  const handleBulkPrint = async () => {
    setLoading(true); // Start loading animation
    console.log("Bulk print started...");

    try {
      const input = printRef.current;
      console.log("Checking printRef for available certificates...");

      if (!input) {
        alert("Nothing to print. Please import data first.");
        console.log("No certificates found. Exiting print function.");
        setLoading(false);
        return;
      }

      // Get all certificates, no filter needed
      const certs = Array.from(input.querySelectorAll(".single-cert"));
      console.log(`Found ${certs.length} certificates for printing.`);

      if (certs.length === 0) {
        alert("No certificates found to print.");
        console.log("No certificates found to print. Exiting print function.");
        setLoading(false);
        return;
      }

      console.log("Generating PDF for all certificates...");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      for (let i = 0; i < certs.length; i++) {
        console.log(`Processing certificate ${i + 1}...`);
        const canvas = await html2canvas(certs[i], {
          scale: 1.5,
          useCORS: true,
          allowTaint: true,
          backgroundColor: "#fff",
          logging: false,
          windowWidth: certs[i].scrollWidth,
          windowHeight: certs[i].scrollHeight,
        });

        console.log(`Converting certificate ${i + 1} to image...`);
        const imgData = canvas.toDataURL("image/jpeg", 0.75);
        const imgProps = pdf.getImageProperties(imgData);
        const imgHeight = (imgProps.height * pdfWidth) / imgProps.width;

        if (i > 0) pdf.addPage(); // Add a new page for each certificate

        console.log(`Adding certificate ${i + 1} to PDF...`);

        if (imgHeight > pdfHeight) {
          const scaledWidth = (imgProps.width * pdfHeight) / imgProps.height;
          pdf.addImage(imgData, "JPEG", 0, 0, scaledWidth, pdfHeight);
        } else {
          pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, imgHeight);
        }
      }

      console.log("Saving the PDF...");
      pdf.save("bulk-flange-certificates.pdf");
      console.log("PDF saved successfully.");
    } catch (error) {
      console.error("Error generating PDF:", error);
      alert("There was an error while generating the PDF.");
    } finally {
      setLoading(false); // Stop loading animation
      console.log("Bulk print process finished.");
    }
  };

  // const fetchTimezones = async () => {
  //   setTimezoneLoading(true);
  //   setTimezoneError("");

  //   try {
  //     const response = await axiosInstance.get(`${API_URL}/api/all_timezones`);

  //     if (response.status === 200 && response.data) {
  //       setTimezones(response.data.timezones || []);
  //     } else {
  //       setTimezoneError(response.data.message || "Failed to load timezones.");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching timezones:", error);
  //     if (error.response) {
  //       setTimezoneError(
  //         error.response.data.message || "Server error occurred."
  //       );
  //     } else if (error.request) {
  //       setTimezoneError("No response from server.");
  //     } else {
  //       setTimezoneError("Unexpected error occurred.");
  //     }
  //   } finally {
  //     setTimezoneLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   if (showPopup) {
  //     fetchTimezones();
  //   }
  // }, [showPopup]);

  useEffect(() => {
    if (showPopup) {
      // fetchTimezones();
      // setSelectedTimezone("");
      // setSelectedTimezone("Asia/Kolkata"); // Set default timezone
    }
    if (selectedFile) {
      // setSnackbarMessage("✅ File imported and data fetched successfully!");
      setShowSnackbar(false);
      return;
    }
  }, [showPopup, selectedFile]);

  const totalPages = Math.ceil(totalRecords / itemsPerPage);

  const handleExistingExcelSubmit = async () => {
    // 1) Guard: must have a file
    if (!existingFile) {
      toast.error("Please choose an Excel file first.");
      return;
    }

    // 2) Resolve the project id from props (fallback to localStorage if needed)
    const projectParam =
      selectedProjectId ||
      JSON.parse(localStorage.getItem("selectedProject") || "null")?.id ||
      JSON.parse(localStorage.getItem("selectedProject") || "null");

    if (!projectParam) {
      toast.error("Project not selected.");
      return;
    }

    try {
      setExistingUploadLoading(true);

      // 3) Build form data
      const formData = new FormData();
      formData.append("file", existingFile);

      // 4) Call your backend using axiosInstance (base URL & auth are already configured)
      const res = await axiosInstance.post(
        `/api/upload_and_edit/${projectParam}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      // 5) Success handling — rely on backend fields (message/updated/skipped)
      const msg = res?.data?.message;
      const updated = Number(res?.data?.updated ?? 0);

      if (updated > 0) {
        toast.success(msg || "Excel updated successfully.");
        // refresh table everywhere that listens
        localStorage.setItem("flangeRefresh", Date.now());
        window.dispatchEvent(new Event("flangeUpdated"));
        // reset UI
        setExistingFile(null);
        setShowPopup(false);
      } else {
        // backend might send a message like "No rows updated"
        toast.warn(
          msg || "No rows were updated. Please verify your Excel file."
        );
      }
    } catch (err) {
      // 6) Error: show backend message (you said it already comes)
      const apiErr =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        "Upload failed.";
      toast.error(apiErr);
    } finally {
      setExistingUploadLoading(false);
    }
  };

  // ---------- clear all field -------- //
  const handleCloseImportPopup = () => {
    setShowPopup(false);

    // reset transient UI state
    setSelectedFile(null);
    setExistingFile(null);
    setSelectedTemplate("");
    setActiveTab("new");

    setImportWarnings([]);
    setShowSheetConfig(false);
    setSheetInfo(null);

    setHeaderConfig(null);
    setHeaderMappingData(null);
    setShowHeaderConfig(false);
    setMappingTab("");

    setSelectedSheets([]);
    setSheetGroupMapping({});
    setSheetMappingError("");
    setCreateGroupSheet(null);
    setNewEquipmentGroup({ code: "", description: "" });
    setCreateGroupError("");
    setMissingTagInfo(null);
    setShowMissingTagsModal(false);

    // if you want to clear imported selection/preview:
    setIsimportted(false);
    setSelectedFlanges([]);
    setAdmins([]);
    setSnackbarMessage("");
    setShowSnackbar(false);
  };

  useEffect(() => {
    if (!canImport && showPopup) {
      setShowPopup(false);
    }
  }, [canImport, showPopup]);

  return (
    <div className={` ${isSidebarExpanded ? "expanded" : "collapsed"}`}>
      <div className="">
        <div className="table-header">
          <div className="">
            <div className=" table-left-side bulkbtnAll-tg">
              {/* <h2 className="jost-bold">All Tags</h2> */}
              {isimportted && selectedFlanges.length > 0 && (
                <div className="import-button impoleft" onClick={handleprint}>
                  <span className="import-icon">
                    <FaPrint />
                  </span>
                  <span>{loading ? "Printing..." : "Print"}</span>
                  {loading && (
                    <div className="loader-overlay">
                      <div className="loader" />
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="table-right-side">
              {/* <div className="import-button" onClick={() => setShowPopup(true)}>
                <span className="import-icon">
                  <AiOutlineUpload />
                </span>
                <span>Import</span>
              </div> */}

              {canImport && (
                <div
                  className={`import-button`}
                  onClick={() => {
                    if (isimportted) {
                      setShowPopup(false);
                      setIsimportted(false);
                      setSelectedFile(null);
                      setSelectedFlanges([]);
                      setAdmins([]);
                    } else {
                      setShowPopup(true);
                    }
                  }}
                >
                  <TbFileImport />

                  <span>Import</span>
                </div>
              )}

              {/* <div className="import-button" onClick={handleExportExcel}>
                <PiExport />
                <span>Export</span>
              </div> */}

              {/* <div className="import-button" onClick={handleBulkPrint}>
    <span className="import-icon">
      <FaPrint />
    </span>
    <span>{printLoading ? "Printing..." : "Bulk Print"}</span>
    {printLoading && (
      <div className="loader-overlay">
        <div className="loader" />
      </div>
    )}
  </div> */}

              <></>
            </div>
          </div>
        </div>

        {canImport && showPopup && (
          <div className="overlay" onClick={handleCloseImportPopup}>
            <div
              className="popup-import brand-import-modal"
              onClick={(e) => e.stopPropagation()}
              style={{ width: "950px", maxHeight: "90vh", height: "auto" }}
            >
              {/* Header */}
              <div className="d-flex justify-content-between align-items-center mb-3 brand-import-header">
                <h4 className="mb-0 brand-import-title">Upload Excel</h4>
                <button
                  type="button"
                  className="btn-close brand-modal-close"
                  aria-label="Close"
                  onClick={handleCloseImportPopup}
                  style={{
                    width: "28px",
                    height: "28px",
                    background: "transparent",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    outline: "0",
                    padding: "0",
                    transition: "background-color 0.2s",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f0f0f0";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                  }}
                >
                  <IoIosClose size={24} color="#666" />
                </button>
              </div>

              {/* Tabs */}
              <div className="d-flex gap-2 mb-3 brand-tab-wrap">
                <button
                  type="button"
                  className={`btn btn-sm ${activeTab === "new" ? "btn-primary" : "btn-outline-primary"
                    } tab-btn brand-tab-btn`}
                  onClick={() => setActiveTab("new")}
                >
                  Upload New Template
                </button>
                <button
                  type="button"
                  className={`btn btn-sm ${activeTab === "existing"
                      ? "btn-primary"
                      : "btn-outline-primary"
                    } tab-btn brand-tab-btn`}
                  onClick={() => setActiveTab("existing")}
                >
                  Update Existing Excel
                </button>
              </div>

              {/* TAB: Upload via Template */}
              {activeTab === "new" && (
                <>
                  <DownloadExcel />

                  <div className="template-select mt-3">
                    <label htmlFor="templates" className="form-label mb-1">
                      Select Template
                    </label>
                    <Select
                      id="templates"
                      required
                      fullWidth
                      displayEmpty
                      value={selectedTemplate}
                      onChange={(e) => setSelectedTemplate(e.target.value)}
                      className="brand-select"
                      sx={{
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#d9b3b3",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#b91c1c",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#b91c1c",
                          boxShadow: "0 0 0 0.2rem rgba(185, 28, 28, 0.2)",
                        },
                      }}
                      renderValue={(value) =>
                        value ? (value === "template1" ? "Template 1" : "Template 2") : "-- Select Template --"
                      }
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            "& .MuiMenuItem-root.Mui-selected": {
                              backgroundColor: "#fbe9e9",
                              color: "#7f1d1d",
                              fontWeight: 600,
                            },
                            "& .MuiMenuItem-root.Mui-selected:hover": {
                              backgroundColor: "#f8dede",
                            },
                            "& .MuiMenuItem-root:hover": {
                              backgroundColor: "#fff5f5",
                            },
                          },
                        },
                      }}
                    >
                      <MenuItem value="" disabled>
                        -- Select Template --
                      </MenuItem>
                      <MenuItem value="template1">Template 1</MenuItem>
                      <MenuItem value="template2">Template 2</MenuItem>
                    </Select>
                    {!selectedTemplate && (
                      <small className="text-muted">
                        Please choose a template to continue.
                      </small>
                    )}
                  </div>

                  <div
                    className="drop-zone dotted-border border-secondary text-center mt-3 brand-drop-zone"
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => {
                      e.preventDefault();
                      const file = e.dataTransfer.files?.[0];
                      if (file) setSelectedFile(file);
                    }}
                  >
                    <p className="mb-2 fs-5">
                      📂 Drag & drop your Excel file here
                    </p>
                    <p className="mb-3 text-muted">or</p>

                    <input
                      type="file"
                      accept=".xlsx, .xls"
                      onChange={(e) =>
                        setSelectedFile(e.target.files?.[0] || null)
                      }
                      className="form-control file-input"
                      disabled={loading}
                    />
                  </div>

                  {/* {selectedFile && (
                    <div className="selected-file-name">
                      ✅ {selectedFile.name}
                    </div>
                  )} */}

                  {timezoneLoading && (
                    <p className="loading-text">Loading timezones...</p>
                  )}
                  {timezoneError && (
                    <p className="error-text">{timezoneError}</p>
                  )}
                  {errorMessage && <p className="error-text">{errorMessage}</p>}

                  <div className="btnspace mt-5 d-flex justify-content-end">
                    <button
                      className="btn mx-2 brand-btn-primary"
                      onClick={handleImportClick}
                      disabled={loading}
                    >
                      {loading ? "Importing..." : "Import"}
                    </button>
                    <button
                      onClick={handleCloseImportPopup}
                      className="btn brand-btn-secondary"
                      disabled={loading}
                    >
                      Cancel
                    </button>
                  </div>
                </>
              )}

              {/* TAB: Upload Existing Excel */}
              {activeTab === "existing" && (
                <>
                  <div
                    className="drop-zone dotted-border border-secondary text-center py-4 brand-drop-zone"
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => {
                      e.preventDefault();
                      const file = e.dataTransfer.files?.[0];
                      if (file) setExistingFile(file);
                    }}
                  >
                    <p className="mb-2 fs-5">
                      📂 Drag & drop your Excel file here
                    </p>
                    <p className="mb-3 text-muted">or</p>

                    <input
                      type="file"
                      className="form-control"
                      accept=".xlsx, .xls"
                      disabled={existingUploadLoading}
                      onChange={(e) =>
                        setExistingFile(e.target.files?.[0] || null)
                      }
                    />
                  </div>

                  <div className="btnspace mt-4 d-flex justify-content-end">
                    <button
                      className="btn mx-2 brand-btn-primary"
                      disabled={existingUploadLoading}
                      onClick={handleExistingExcelSubmit}
                    >
                      {existingUploadLoading ? "Uploading..." : "Submit"}
                    </button>

                    <button
                      onClick={handleCloseImportPopup}
                      className="btn brand-btn-secondary"
                      disabled={existingUploadLoading}
                    >
                      Cancel
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {showSheetConfig && sheetInfo && (
          <div className="overlay flange-sheet-overlay">
            <div className="popup-import flange-sheet-modal" role="dialog" aria-modal="true" aria-labelledby="sheet-config-title">
              <div>
                <div className="modal-header flange-sheet-header">
                  <div>
                    <div className="flange-sheet-title-row">
                      <h4 className="modal-title" id="sheet-config-title">Choose sheets &amp; equipment groups</h4>
                      <span className="flange-header-sheet-count">
                        {(sheetInfo.sheet_mappings || []).length}{" "}
                        {(sheetInfo.sheet_mappings || []).length === 1 ? "sheet" : "sheets"}
                      </span>
                    </div>
                    <p>Automatically matched from your Excel file. Review before continuing.</p>
                  </div>
                  <button
                    type="button"
                    className="flange-sheet-close"
                    aria-label="Close"
                    onClick={() => setShowSheetConfig(false)}
                    disabled={sheetConfigLoading}
                  >
                    &times;
                  </button>
                </div>

                <form onSubmit={handleSheetConfigSubmit}>
                  <div
                    className="modal-body flange-sheet-body"
                  >
                    {sheetMappingError && (
                      <div className="flange-mapping-error" role="alert">
                        {sheetMappingError}
                      </div>
                    )}

                    <div className="flange-mapping-table-wrap">
                      <table className="flange-mapping-table">
                        <thead>
                          <tr>
                            <th>
                              <label className="flange-sheet-select-all">
                                <input
                                  type="checkbox"
                                  checked={
                                    (sheetInfo.sheet_mappings || []).length > 0 &&
                                    selectedSheets.length === (sheetInfo.sheet_mappings || []).length
                                  }
                                  onChange={(event) => {
                                    setSelectedSheets(
                                      event.target.checked
                                        ? (sheetInfo.sheet_mappings || []).map((sheet) => sheet.sheet_name)
                                        : []
                                    );
                                    setSheetMappingError("");
                                  }}
                                  disabled={sheetConfigLoading}
                                  aria-label="Select all sheets"
                                />
                                <span>Sheet name</span>
                              </label>
                            </th>
                            <th>Equipment group</th>
                            <th>Confidence</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(sheetInfo.sheet_mappings || []).map((sheet) => {
                            const confidence = String(sheet.confidence || "low").toLowerCase();
                            return (
                              <tr
                                key={sheet.sheet_name}
                                className={`${confidence === "low" || confidence === "none" ? "needs-review" : ""} ${!selectedSheets.includes(sheet.sheet_name) ? "not-selected" : ""}`}
                              >
                                <td>
                                  <label className="flange-sheet-row-select">
                                    <input
                                      type="checkbox"
                                      checked={selectedSheets.includes(sheet.sheet_name)}
                                      onChange={(event) => {
                                        setSelectedSheets((current) =>
                                          event.target.checked
                                            ? [...current, sheet.sheet_name]
                                            : current.filter((name) => name !== sheet.sheet_name)
                                        );
                                        setSheetMappingError("");
                                      }}
                                      disabled={sheetConfigLoading}
                                      aria-label={`Import ${sheet.sheet_name} sheet`}
                                    />
                                    <strong>{sheet.sheet_name}</strong>
                                  </label>
                                  {(confidence === "low" || confidence === "none") && (
                                    <small>Review required</small>
                                  )}
                                </td>
                                <td>
                                  <div className="flange-group-select-wrap">
                                  <Select
                                    className="flange-group-select"
                                    fullWidth
                                    displayEmpty
                                    size="small"
                                    value={sheetGroupMapping[sheet.sheet_name] || ""}
                                    onChange={(event) => {
                                      if (event.target.value === "__create_group__") {
                                        setCreateGroupSheet(sheet.sheet_name);
                                        setNewEquipmentGroup({
                                          code: "",
                                          description: sheet.sheet_name,
                                        });
                                        setCreateGroupError("");
                                        return;
                                      }
                                      setSheetGroupMapping((current) => ({
                                        ...current,
                                        [sheet.sheet_name]: event.target.value || null,
                                      }));
                                      setSheetMappingError("");
                                    }}
                                    disabled={
                                      sheetConfigLoading ||
                                      !selectedSheets.includes(sheet.sheet_name)
                                    }
                                    inputProps={{
                                      "aria-label": `Equipment group for ${sheet.sheet_name}`,
                                    }}
                                    renderValue={(value) => {
                                      if (!value) return <span className="flange-select-placeholder">Select equipment group</span>;
                                      return (sheetInfo.all_equipment_groups || []).find(
                                        (group) => group.id === value
                                      )?.description || value;
                                    }}
                                    MenuProps={{
                                      PaperProps: {
                                        className: "flange-group-menu",
                                        elevation: 8,
                                      },
                                      MenuListProps: { dense: true },
                                    }}
                                  >
                                    <MenuItem value="__placeholder__" disabled>
                                      Select equipment group
                                    </MenuItem>
                                    <MenuItem
                                      value="__create_group__"
                                      className="flange-create-group-option"
                                    >
                                      <FiPlus aria-hidden="true" />
                                      Create new equipment group
                                    </MenuItem>
                                    {(sheetInfo.all_equipment_groups || []).map((group) => (
                                      <MenuItem key={group.id} value={group.id}>
                                        {group.description}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                  {sheetGroupMapping[sheet.sheet_name] &&
                                    selectedSheets.includes(sheet.sheet_name) && (
                                      <button
                                        type="button"
                                        className="flange-clear-group-button"
                                        aria-label={`Clear equipment group for ${sheet.sheet_name}`}
                                        title="Clear mapping"
                                        onMouseDown={(event) => event.stopPropagation()}
                                        onClick={(event) => {
                                          event.stopPropagation();
                                          setSheetGroupMapping((current) => ({
                                            ...current,
                                            [sheet.sheet_name]: null,
                                          }));
                                          setSheetMappingError("");
                                        }}
                                        disabled={sheetConfigLoading}
                                      >
                                        &times;
                                      </button>
                                    )}
                                  </div>
                                </td>
                                <td>
                                  <span className={`flange-confidence ${confidence}`}>
                                    {confidence === "none" ? "Low" : confidence}
                                  </span>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="modal-footer flange-sheet-footer">
                    <span className="flange-sheet-footer-hint">
                      <FiInfo aria-hidden="true" />
                      You can review header mappings in the next step.
                    </span>
                    <div className="flange-sheet-actions">
                    <button
                      type="button"
                      className="btn brand-btn-secondary"
                      onClick={() => setShowSheetConfig(false)}
                      disabled={sheetConfigLoading}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn brand-btn-primary"
                      disabled={
                        sheetConfigLoading ||
                        selectedSheets.length === 0 ||
                        (sheetInfo.sheet_mappings || []).some(
                          (sheet) =>
                            selectedSheets.includes(sheet.sheet_name) &&
                            !sheetGroupMapping[sheet.sheet_name]
                        )
                      }
                    >
                      {sheetConfigLoading ? "Processing sheets..." : "Continue to header mapping"}
                    </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        {createGroupSheet && (
          <div className="overlay flange-create-group-overlay">
            <form
              className="flange-create-group-dialog"
              onSubmit={handleCreateEquipmentGroup}
              role="dialog"
              aria-modal="true"
              aria-labelledby="create-equipment-group-title"
            >
              <div className="flange-create-group-header">
                <div>
                  <span>New equipment group</span>
                  <h4 id="create-equipment-group-title">Create and select a group</h4>
                  <p>For sheet: <strong>{createGroupSheet}</strong></p>
                </div>
                <button
                  type="button"
                  aria-label="Close equipment group form"
                  onClick={() => setCreateGroupSheet(null)}
                  disabled={createGroupLoading}
                >
                  &times;
                </button>
              </div>

              <div className="flange-create-group-body">
                {createGroupError && (
                  <div className="flange-mapping-error" role="alert">
                    {createGroupError}
                  </div>
                )}
                <label>
                  <span>Group code</span>
                  <input
                    value={newEquipmentGroup.code}
                    onChange={(event) =>
                      setNewEquipmentGroup((current) => ({
                        ...current,
                        code: event.target.value.toUpperCase().slice(0, 5),
                      }))
                    }
                    maxLength={5}
                    placeholder="e.g. PSV"
                    autoFocus
                    disabled={createGroupLoading}
                  />
                  <small>Maximum 5 characters</small>
                </label>
                <label>
                  <span>Group name</span>
                  <input
                    value={newEquipmentGroup.description}
                    onChange={(event) =>
                      setNewEquipmentGroup((current) => ({
                        ...current,
                        description: event.target.value.slice(0, 45),
                      }))
                    }
                    maxLength={45}
                    placeholder="Equipment group name"
                    disabled={createGroupLoading}
                  />
                </label>
              </div>

              <div className="flange-create-group-footer">
                <button
                  type="button"
                  className="btn brand-btn-secondary"
                  onClick={() => setCreateGroupSheet(null)}
                  disabled={createGroupLoading}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn brand-btn-primary"
                  disabled={
                    createGroupLoading ||
                    !newEquipmentGroup.code.trim() ||
                    !newEquipmentGroup.description.trim()
                  }
                >
                  {createGroupLoading ? "Creating..." : "Create and select"}
                </button>
              </div>
            </form>
          </div>
        )}

        {/* {showHeaderConfig && headerConfig?.header_data && Object.keys(headerConfig.header_data).length > 0 &&  (
  <div className="modal show d-block" tabIndex="-1">
    <div className="modal-dialog modal-xl modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header bg-dark text-white">
          <h5 className="modal-title"> Map or Confirm Headers</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setShowHeaderConfig(false)}
          />
        </div>

        <div className="modal-body" style={{ maxHeight: "70vh", overflowY: "auto" }}>
          {Object.entries(headerConfig.header_data).map(([sheet, headers]) => (
            <div key={sheet} className="mb-4">
              <h6 className="text-primary">{sheet}</h6>
              <div className="row row-cols-2 row-cols-md-3 g-2">
                {headers.map((header, idx) => (
                  <div key={idx} className="col">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id={`${sheet}-${idx}`}
                        defaultValue={header}
                        onChange={(e) => handleHeaderChange(sheet, idx, e.target.value)}
                      />
                      <label htmlFor={`${sheet}-${idx}`}>Header {idx + 1}</label>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="modal-footer">
          <button type="button" className="btn btn-success" onClick={handleHeaderConfigSubmit}>
           Confirm & Import
          </button>
          <button type="button" className="btn btn-secondary" onClick={() => setShowHeaderConfig(false)}>
             Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
)} */}

        {showHeaderConfig &&
          headerConfig?.header_data &&
          Object.keys(headerConfig.header_data).length > 0 && (
            <div
              className="overlay"
              tabIndex="-1"
              style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
            >
              <div className="popup-import">
                <div>
                  <div className="modal-header">
                    <h4 className="modal-title mb-4">Confirm Headers</h4>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowHeaderConfig(false)}
                      disabled={isLoading}
                    />
                  </div>

                  <div
                    className="modal-body"
                    style={{ maxHeight: "70vh", overflowY: "auto" }}
                  >
                    {/* Tabs */}
                    <ul className="nav nav-tabs mb-3">
                      {Object.keys(headerConfig.header_data).map((sheet) => (
                        <li key={sheet} className="nav-item">
                          <button
                            type="button"
                            className={`nav-link ${mappingTab === sheet ? "active" : ""
                              }`}
                            onClick={() => setMappingTab(sheet)}
                          >
                            {sheet}
                          </button>
                        </li>
                      ))}
                    </ul>

                    {/* Tab Content */}
                    {Object.entries(headerConfig.header_data).map(
                      ([sheetName, sheetData]) => {
                        if (sheetName !== mappingTab) return null;

                        const { detected_headers = [], mappings = {} } =
                          sheetData;

                        return (
                          <div key={sheetName} className="tab-pane active">
                            <div className="table-responsive">
                              <table className="table table-bordered align-middle small">
                                <thead className="table-light">
                                  <tr>
                                    <th>Field Name</th>
                                    <th>Mapped to Detected Header</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {Object.entries(mappings).map(
                                    ([field, mappedValue], idx) => (
                                      <tr key={idx}>
                                        <td>{field}</td>
                                        <td>
                                          {[
                                            "flange size unit",
                                            "spanner size unit",
                                            "stud length unit",
                                            "stud size unit",
                                          ].includes(field) ? (
                                            // 🔒 Just show value, not editable
                                            <input
                                              className="form-control"
                                              value={mappedValue || ""}
                                              disabled
                                            />
                                          ) : (
                                            // 🔁 Editable select for other fields
                                            <select
                                              className="form-select"
                                              value={mappedValue || ""}
                                              onChange={(e) =>
                                                handleHeaderChange(
                                                  sheetName,
                                                  field,
                                                  e.target.value
                                                )
                                              }
                                            >
                                              <option value="">
                                                -- Select Header --
                                              </option>
                                              {detected_headers.map(
                                                (header, i) => (
                                                  <option
                                                    key={i}
                                                    value={header}
                                                  >
                                                    {header}
                                                  </option>
                                                )
                                              )}
                                            </select>
                                          )}
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        );
                      }
                    )}
                  </div>

                  <div className="modal-footer mt-3">
                    <button
                      className="btn btn-success me-3"
                      onClick={() => {
                        handleHeaderConfigSubmit({
                          isPassconfirm_missing_tags: false,
                          value: "",
                        });
                      }}
                      disabled={isLoading}
                    >
                      {isLoading ? "Importing..." : "Confirm & Import"}
                    </button>

                    <button
                      className="btn btn-secondary"
                      onClick={() => setShowHeaderConfig(false)}
                      disabled={isLoading}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

        {isLoading && <Loader />}

        {/* {loading && (
          <div className="loader-container">
            <div className="loader"></div>
          </div>
        )} */}

        {importWarnings.length > 0 && (
          <div className="alert alert-warning mt-3">
            <h6>⚠️ Warnings:</h6>
            <ul className="mb-0">
              {importWarnings.map((warning, idx) => (
                <li key={idx}>{warning}</li>
              ))}
            </ul>
            <button
              onClick={handleClosePopup}
              className="btn btn-danger"
              disabled={loading}
            >
              Cancel
            </button>
          </div>
        )}

        {showMissingTagsModal && (
          <div
            className="overlay"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="popup-import">
              <div className="modal-header">
                <h5 className="modal-title">Missing Tag Numbers</h5>
                <button
                  className="btn-close"
                  onClick={() => setShowMissingTagsModal(false)}
                />
              </div>

              <div
                className="modal-body"
                style={{ maxHeight: "60vh", overflowY: "auto" }}
              >
                <p>
                  Tag number is missing for the following rows. Do you want to
                  continue importing them anyway?
                </p>
                <ul className="list-group small">
                  {missingTagInfo?.map((item, index) => (
                    <li key={index} className="list-group-item">
                      <strong>Sheet:</strong> {item.sheet} &nbsp; | &nbsp;
                      <strong>Row:</strong> {item.row_index}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-danger me-2"
                  disabled={isLoading}
                  onClick={() => {
                    setShowMissingTagsModal(false);
                    handleHeaderConfigSubmit({
                      isPassconfirm_missing_tags: true,
                      value: false,
                    }); // ✅ Call with confirm_missing_tags: fals
                    // Do NOT proceed
                  }}
                >
                  Cancel Import
                </button>

                <button
                  className="btn btn-primary"
                  disabled={isLoading}
                  onClick={() => {
                    setShowMissingTagsModal(false);
                    handleHeaderConfigSubmit({
                      isPassconfirm_missing_tags: true,
                      value: true,
                    }); // ✅ NOW call with confirm_missing_tags: true
                  }}
                >
                  Confirm & Import Anyway
                </button>
              </div>
            </div>
          </div>
        )}

        {/* <div className="data-list-body">
  <div className="data-list-scroll-body">
    <div className="data-list-table flange-table-container">
      <table className="table multilevel-data flange-table">
        <thead className="table-dark flange-table-head">
          <tr className="table-row">
            <th></th>
            <th>Sr-no</th>
            <th>Work Order Number</th>
            <th>Unit Name</th>
            <th>Equipment No</th>
            <th>Equipment Name</th>
            <th>Flange Size</th>
            <th>Rating</th>
            <th>Required Torque</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan="10" className="text-center">
                <Box display="flex" justifyContent="center" p={2}>
                  <CircularProgress />
                </Box>
              </td>
            </tr>
          ) : currentAdmins.length > 0 ? (
            currentAdmins.map((admin, index) => (
              <tr key={admin.flange_id}>
                <td>
                  <input
                    type="checkbox"
                    checked={selectedFlanges.includes(admin.flange_id)}
                    onChange={(e) => {
                      const isChecked = e.target.checked;
                      setSelectedFlanges((prev) => {
                        const updated = isChecked
                          ? [...prev, admin.flange_id]
                          : prev.filter((id) => id !== admin.flange_id);
                        // setIsimportted(updated.length > 0);
                        return updated;
                      });
                    }}
                  />
                </td>
                <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                <td>{admin.work_order_id || "N/A"}</td>
                <td>{admin.unit_name || "N/A"}</td>
                <td>{admin.equipment_number || "N/A"}</td>
                <td>{admin.equipment_name || "N/A"}</td>
                <td>{admin.flange_size || "N/A"}</td>
                <td>{admin.rating || "N/A"}</td>
                <td>{admin.required_torque || "N/A"}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="10" className="text-center">No data available</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
   
  </div>

  
</div> */}
        {/* Sticky Footer Pagination */}
        {/* <div className="table-footer form-footer">
  <div className="pagination-controls flex justify-center items-center gap-4 py-4">
    <span className="text-gray-600 text-sm">
      Total Records: <strong>{totalRecords}</strong>
    </span>
   

    <span
  onClick={() => currentPage > 1 && totalRecords > 0 && setCurrentPage(currentPage - 1)}
  style={{
    fontSize: "14px",
    color: currentPage === 1 || totalRecords === 0 ? "#ccc" : "#0070f3",
    cursor: currentPage === 1 || totalRecords === 0 ? "default" : "pointer",
    textDecoration: currentPage === 1 || totalRecords === 0 ? "none" : "none",
  }}
>
  Previous
</span>


    <span style={{ fontSize: "14px", color: "#333" }}>
  {totalRecords === 0
    ? "No records to display"
    : `Page ${currentPage} of ${Math.ceil(totalRecords / itemsPerPage)}`}
</span>

   <span
  onClick={() =>
    currentPage < Math.ceil(totalRecords / itemsPerPage) &&
    totalRecords > 0 &&
    setCurrentPage(currentPage + 1)
  }
  style={{
    fontSize: "14px",
    color: currentPage === Math.ceil(totalRecords / itemsPerPage) || totalRecords === 0
      ? "#ccc"
      : "#fff",
    cursor: currentPage === Math.ceil(totalRecords / itemsPerPage) || totalRecords === 0
      ? "default"
      : "pointer",
    textDecoration: currentPage === Math.ceil(totalRecords / itemsPerPage) || totalRecords === 0
      ? "none"
      : "none",
  }}
>
  Next
</span>
  </div>
</div> */}
      </div>

      <div ref={printRef} id="bulk-print-area" className="print-only">
        {admins
          // .filter((admin) => selectedFlanges.includes(admin.flange_id))
          .map((admin, index) => (
            <div
              key={index}
              className="single-cert page-break"
              style={certStyle}
              data-flange-id={admin.flange_id} // Add this line for identification
            >
              {/* Certificate Front Side */}
              <div className="tag-container">
                <div className="tag-content">
                  <h2 className="company-name">Jecon Engineers Pvt. Ltd.</h2>
                  <h3 className="title">FLANGE TIGHTENED</h3>

                  <div className="check-section">
                    <div className="check-item">
                      <label>TENSIONED</label>
                      <input
                        type="checkbox"
                        className="certificate-checked"
                        checked={
                          admin?.method_of_tightening?.toLowerCase() ===
                          "tensioning"
                        }
                        readOnly
                      />
                    </div>
                    <div className="check-item">
                      <label>TORQUED</label>
                      <input
                        type="checkbox"
                        className="certificate-checked"
                        checked={
                          admin?.method_of_tightening?.toLowerCase() ===
                          "torquing"
                        }
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="main-form">
                    <div className="form-section">
                      <div className="form-item">
                        <label className="form-label form-input-1">
                          CERT#:
                        </label>
                        <input
                          type="text"
                          className="form-input input-certificate"
                          value={admin?.certificate_no || ""}
                          readOnly
                        />
                      </div>
                      <div className="form-item">
                        <label className="form-label form-input-2">
                          SIGNED:
                        </label>
                        <input
                          type="text"
                          className="form-input input-certificate-2"
                          value={admin?.signed_by || ""}
                          readOnly
                        />
                      </div>
                      <div className="form-item">
                        <label className="form-label form-input-3">DATE:</label>
                        <input
                          type="date"
                          className="form-input input-certificate-3"
                        // value={admin?.date || ""}
                        // readOnly
                        />
                      </div>
                    </div>

                    {admin?.qr_code && (
                      <div className="qr-image">
                        <img
                          src={`data:image/png;base64,${admin.qr_code}`}
                          alt="QR Code"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Flange Tag Back Side */}
              <div className="flange-tag">
                <div className="tag-hole" />

                {/* Date Row */}
                <div className="tag-row">
                  <div className="tag-label">Date</div>
                  <div className="tag-line">
                    <input
                      type="text"
                    // // defaultValue={admin?.date || ""}
                    // readOnly
                    />
                  </div>
                </div>

                {/* Title (after date) */}
                <div className="tag-title">Flange Joint Identification Tag</div>

                {/* Rest of the fields */}
                {[
                  { label: "Flange Size", value: admin?.flange_size },
                  { label: "Flange Rating", value: admin?.rating },
                  { label: "Gasket Type", value: admin?.gasket_type },
                  { label: "Stud / Nut MOC", value: admin?.stud_nut_moc },
                  { label: "Bolt Diameter", value: admin?.bolt_diameter },
                  {
                    label: (
                      <>
                        Method of
                        <br />
                        tightening
                      </>
                    ),
                    value: admin?.method_of_tightening,
                  },

                  { label: "Lubricant used", value: admin?.lubricant_used },
                  {
                    label: (
                      <>
                        Required
                        <br />
                        Torque
                      </>
                    ),
                    value: admin?.required_torque,
                  },

                  {
                    label: (
                      <>
                        Achieved
                        <br />
                        Torque
                      </>
                    ),
                    value: admin?.achieved_torque,
                  },

                  { label: "QC Sign", value: admin?.qc_sign },
                ].map((item, i) => (
                  <div key={i} className="tag-row">
                    <div className="tag-label">{item.label}</div>
                    <div className="tag-line">
                      <input
                        type="text"
                        defaultValue={item.value || ""}
                        readOnly
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
      </div>
      <Snackbar
        open={showSnackbar}
        autoHideDuration={4000}
        onClose={() => setShowSnackbar(false)}
        message={snackbarMessage}
      />

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
    </div>
  );
}

export default AllTags;
